export const isRecent = (int: number) => {
  if (int === 0) return false
  return new Date().getTime() - int < 12000
}
